var mode = process.env.NODE_ENV || 'development';

var config = require(`./${mode}/client.config`);

export default config;



// WEBPACK FOOTER //
// ./configs/client.js